import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router";

import Avatar from "./Avatar";
import ChatActions from "../../actions/ChatActions";

export default class ResponseSwitcher extends Component {
    constructor() {
        super();

        this.onSwitchToResponse = this.onSwitchToResponse.bind(this);
    }

    onSwitchToResponse() {
        ChatActions.hideResponseSwitcher();
        ChatActions.clearActionBar();
    }

    render() {
        const { currentResponseId, latestAnswerForAllResponses, questionUuid, responses } = this.props;

        return (
            <div className="response-switcher">
                {responses.map(response => (
                    <Link
                        className={classNames({
                            "response-switcher-item": true,
                            "has-notification": !response.isViewedByUser,
                            "is-current": response.id === currentResponseId,
                        })}
                        key={response.id}
                        onClick={this.onSwitchToResponse}
                        to={`question/${questionUuid}?responseId=${response.id}`}
                    >
                        {!response.isViewedByUser && response.id !== currentResponseId && (
                            <div className="unread-notifications">
                                <strong>{response.unreadMessageCount}</strong>
                            </div>
                        )}
                        <Avatar
                            name={latestAnswerForAllResponses[response.id].author.name}
                            size={54}
                            src={latestAnswerForAllResponses[response.id].author.avatarSrc}
                        />
                    </Link>
                ))}
                {responses.length <= 1 && (
                    <div className="one-expert-filler">
                        <div className="avatar avatar-placeholder" />
                        <div className="avatar avatar-placeholder" />
                        <p>{i18n.t("rtm.text.answers_from_experts")}</p>
                    </div>
                )}
            </div>
        );
    }
}

ResponseSwitcher.propTypes = {
    currentResponseId: PropTypes.number.isRequired,
    questionUuid: PropTypes.string.isRequired,
    latestAnswerForAllResponses: PropTypes.shape({}).isRequired,
    responses: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
};
